type KebabCase = `${Lowercase<string>}-${Lowercase<string>}`;

type FeatureFlagKey = `${number}-${KebabCase}`;

type FeatureFlags = {
  [K in FeatureFlagKey]?: boolean;
};

export const featureFlags: FeatureFlags = {
  "13676-search-by-owner-bu": false,
  "14136-paid-maintenance": true,
  "15444-payment-plans-accordion": true,
  "15999-lazy-routing": true,
} as const;

export type FeatureFlag = keyof typeof featureFlags;
